import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export const useIncomes = ({ userId, year, week } = {}) => {
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchIncomes = useCallback(async () => {
    if (!userId) {
      setIncomes([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const params = { userId };
    if (year != null) params.year = year;
    if (week != null) params.week = week;

    const response = await api.get('/incomes', {
      params,
    });

    if (!response?.ok) {
      setIncomes([]);
      setLoading(false);
      return;
    }

    setIncomes(response.data.data || []);
    setLoading(false);
  }, [userId, year, week]);

  useEffect(() => {
    fetchIncomes();
  }, [fetchIncomes]);

  return { data: incomes, loading, refetch: fetchIncomes };
};
